import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Web: render sticky bar via portal into document.body so it stays fixed at bottom.
 */
function renderStickyBar(content: React.ReactNode): React.ReactNode {
  if (typeof document === 'undefined') {
    return content;
  }
  return createPortal(content, document.body);
}

export default renderStickyBar;
